var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 0A.75.75 0 0 0 .5.75v7.5a.75.75 0 0 0 .75.75H2v9h7.5v-4.5c0-.836.664-1.5 1.5-1.5s1.5.664 1.5 1.5V18H20V9h.75a.75.75 0 0 0 .75-.75V.75a.75.75 0 0 0-.75-.75H1.25ZM2 1.5h18v6h-6.287L11.67 3.416a.75.75 0 0 0-1.342 0L8.287 7.5H2v-6Zm9 3.926 1.58 3.158a.75.75 0 0 0 .67.416h5.25v7.5H14v-3c0-1.648-1.352-3-3-3s-3 1.352-3 3v3H3.5V9h5.25a.75.75 0 0 0 .67-.416L11 5.426ZM5 10.5v3h1.5v-3H5Zm10.5 0v3H17v-3h-1.5Z",
  fill: "#111"
})));
export default SvgHome;